module.exports = __webpack_public_path__ + "img/no_data_order.c3db93f0.png";